import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { v4 as uuidv4 } from 'uuid';

import { openFilterById } from 'src/app/common/utils';

import { FilterType, FilterOperator } from '../../enums';
import { Filter, PageFilterWhereFilterGroupFilter } from '../../types';

@Component({
  selector: 'app-page-filter-group',
  templateUrl: './page-filter-group.component.html',
  styleUrls: ['./page-filter-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFilterGroupComponent implements OnChanges {
  private invalidFilters: { [key: string]: boolean } = {};

  allowedFilters = [
    {
      title: 'Page Property',
      type: FilterType.PageProperty,
    },
  ];
  FilterType = FilterType;

  @Input() filterGroup: PageFilterWhereFilterGroupFilter | null = null;

  @Output() activateFilters: EventEmitter<boolean> = new EventEmitter();
  @Output() remove = new EventEmitter();
  @Output() update: EventEmitter<PageFilterWhereFilterGroupFilter> =
    new EventEmitter();

  constructor() {}

  ngOnChanges({ filterGroup }: SimpleChanges) {
    const group = filterGroup?.currentValue;

    if (group && !group.filters) {
      this.update.emit({ ...group, filters: [] });
    } else if (group.filters?.length > 1 && !group.operator) {
      this.update.emit({
        ...group,
        operator: FilterOperator.AND,
      });
    } else if (group.filters?.length === 1 && group.operator) {
      this.update.emit({
        ...group,
        operator: undefined,
      });
    }
  }

  private updateValidation() {
    this.activateFilters.emit(
      Object.keys(this.invalidFilters).every(key => !this.invalidFilters[key])
    );
  }

  handleFinish(id: string, isFilterValid: boolean) {
    this.invalidFilters[id] = !isFilterValid;

    this.updateValidation();
  }

  trackByFilter(index: number, filter: Filter) {
    return filter.id;
  }

  addFilter(filterType: FilterType) {
    if (this.filterGroup) {
      const id = uuidv4();

      this.update.emit({
        ...this.filterGroup,
        filters: [
          ...this.filterGroup.filters,
          {
            id,
            filterType,
          },
        ],
      });

      openFilterById(id);
    }
  }

  updateOperator(operator: FilterOperator) {
    if (this.filterGroup) {
      this.update.emit({
        ...this.filterGroup,
        operator,
      });

      this.updateValidation();
    }
  }

  removeFilter(id: string, index: number) {
    delete this.invalidFilters[id];

    if (this.filterGroup) {
      const filters = this.filterGroup.filters.filter((f, i) => i !== index);
      this.update.emit({
        ...this.filterGroup,
        operator: filters.length > 1 ? this.filterGroup.operator : undefined,
        filters,
      });
    }

    this.updateValidation();
  }

  updateFilter(filter: Filter) {
    if (this.filterGroup) {
      this.update.emit({
        ...this.filterGroup,
        filters: this.filterGroup.filters.map(f =>
          f.id === filter.id ? filter : f
        ),
      });
    }
  }
}
